import { getAuth, signInAnonymously } from 'firebase/auth'
import { getFirestore, doc, collection, where, onSnapshot, query, getDocs } from '@firebase/firestore'
import store from '@/store'
import userConverter from '@/classes/User/userConverter'
import router from '@/routes'
import abrechnungConverter from '@/classes/Abrechnung/abrechnungConverter'
import kostenartConverter from '@/classes/Abrechnung/Kosten/kostenartConverter'
import pauschalenartConverter from '@/classes/Abrechnung/Kosten/pauschalenartConverter'
import md5 from 'md5'

const auth = getAuth()
const db = getFirestore()

const UserModule = {
  state: {
    user: {
      loggedIn: false,
      loader: true,
      ms: false,
      loggedOut: false,
      data: null,
    },
    abrechnungen: {
      eigene: [],
      kreis_alle: [],
      abteilung_alle: [],
      finanzen_alle: [],
      KreisSnap: '',
      KKSnap: '',

    },
    kostenstellen: {
      kreis: [],
      verband: []
    },
    kostentraeger: [],
    loader: {
      active: true
    },
    kostenarten: [],
    pauschalenarten: [],
    open_search: false,
    vorlagen: []
  },
  getters: {
    user(state) {
      return state.user
    },
    userdaten(state){
      return state.user.data
    },
    abrechnungen(state) {
      return state.abrechnungen
    },
    aktuelle_abrechnungen(state) {
      return state.abrechnungen.eigene.filter(a => a.status === 'Neu').sort((a, b) => {
        const ta = a.historie?.[0]?.timestamp;
        const tb = b.historie?.[0]?.timestamp;
        // Versuche, als Date zu vergleichen (absteigend)
        const dateA = ta ? new Date(ta).getTime() : 0;
        const dateB = tb ? new Date(tb).getTime() : 0;
        return dateB - dateA;
      });
    },
    loader(state) {
      return state.loader
    },
    kostenstellen(state) {
      return state.kostenstellen
    },
    kostentraeger(state) {
      return state.kostentraeger
    },
    kostenarten(state) {
      return state.kostenarten
    },
    pauschalenarten(state) {
      return state.pauschalenarten
    },
    vorlagen(state) {
      return state.vorlagen
    },
    open_search(state) {
      return state.open_search
    }
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      state.user.loggedIn = value
    },
    SET_LOGGED_OUT(state, value) {
      state.user.loggedOut = value
    },
    SET_LOADING(state, value) {
      state.loader.active = value
    },
    async SET_USER(state, data) {
      state.user.data = data
      state.loader.active = false
      if(!data || data === null){
        return
      }
      state.user.ms = data.providerData?.find(p => p.providerId === 'microsoft.com') ? true : false
      const abrechnungenDocs = query(collection(getFirestore(), 'Abrechnungen'), where('abrechnender.id', '==', data.id)).withConverter(abrechnungConverter)
      const abrechnungSnap = onSnapshot(abrechnungenDocs, (abrechnungen) => {
        state.abrechnungen.eigene = []
        abrechnungen.forEach(abrechnung => {
          var daten = abrechnung.data()
          state.abrechnungen.eigene.push(daten)
        })
      })
      
      const vorlagenDocs = query(collection(getFirestore(), 'User/'+data.id+'/Vorlagen'), where('abrechnender.id', '==', data.id)).withConverter(abrechnungConverter)
      const vorlagenSnap = onSnapshot(vorlagenDocs, (vorlagen) => {
        state.vorlagen = []
        vorlagen.forEach(vorlage => {
          var daten = vorlage.data()
          state.vorlagen.push(daten)
        })
      })
      await data.checkRollen()
      if(data.kv() || data.kk() || data.ka()){
        const kreise = data.ausschuesse.map(item => { return item.kreisId })
        const ausschuss = data.ausschuesse.map(item => { return item.ausschussId })

        var q = query(collection(getFirestore(), 'Abrechnungen'),
          where('empfaenger.refId', '==', parseInt(data.customFields.kreis))
        )

        if(!data.kv() && !data.kk() && data.ka()){
          if(kreise.length > 0 || ausschuss.length > 0) {
            q = query(collection(getFirestore(), 'Abrechnungen'),
              where('empfaenger.refId', 'in', kreise)
            )
          }
          
        }
      }

      state.kostenstellen.kreis = []
      const kreiskostenstellenDocs = collection(getFirestore(), 'Kreiskostenstellen')
      const kreiskostenstellen = await getDocs(kreiskostenstellenDocs)
      kreiskostenstellen.forEach(item => {
        state.kostenstellen.kreis.push(Object.assign({}, item.data()))
      })
      state.kostenstellen.verband = []
      const kostenstellenDocs = collection(getFirestore(), 'Kostenstellen')
      const kostenstellen = await getDocs(kostenstellenDocs)
      kostenstellen.forEach(item => {
        state.kostenstellen.verband.push(Object.assign({}, item.data()))
      })
      state.kostentraeger = []
        const kostentraegerDocs = collection(getFirestore(), 'Kostentraeger')
        const kostentraeger = await getDocs(kostentraegerDocs)
        kostentraeger.forEach(item => {
          state.kostentraeger.push(Object.assign({}, item.data()))
      })

      state.kostenarten = []
      const kostenartenDocs = collection(getFirestore(), 'Kostenarten').withConverter(kostenartConverter)
      const kostenarten = await getDocs(kostenartenDocs)
      kostenarten.forEach(item => {
        state.kostenarten.push(item.data())
      })

      state.pauschalenarten = []
      const pauschalenartenDocs = collection(getFirestore(), 'Pauschalenarten').withConverter(pauschalenartConverter)
      const pauschalenarten = await getDocs(pauschalenartenDocs)
      pauschalenarten.forEach(p => {
        state.pauschalenarten.push(p.data())
      })
    },
    RESET_KOSTENARTEN(state){
      state.kostenarten = []
    },
    ADD_KOSTENART(state, data) {
      state.kostenarten.push(data)
      state.kostenarten.sort((a, b) => a.name < b.name ? -1 : 1)
    },
    SET_PAUSCHALENARTEN(state) {
      state.pauschalenarten = []
    },
    ADD_PAUSCHALENART(state, data) {
      state.pauschalenarten.push(data)
      state.pauschalenarten.sort((a, b) => a.name < b.name ? -1 : 1)
    },
  },
  actions: {
    fetchUser({ commit }, user) {
      commit('SET_LOGGED_IN', user !== null)
        
      if (user) {
        var photoUrl = '/icons/SVG/user.svg'
        var email = user.email
        var name = []

        if(user.displayName){
          name = user.displayName.split(', ')
        }

        const userDoc = doc(db, 'User/' + user.uid).withConverter(userConverter)
        
        const snap = onSnapshot(userDoc, (userdoc) => {
          if (userdoc.exists()) {
            user = userdoc.data()
            user.photoUrl = photoUrl
            user.email = email
            commit('SET_USER', user)
            if(user.customFields.fill){
              router.push('/profil-vervollstaendigen').catch(error => {
                if(error.name != "NavigationDuplicated"){
                  console.log(error)
                  throw error
                }
              })
            }
            return
          }
        })

        
      } else {
        commit('SET_USER', null)
      }
    },
    showLoggedOut({ commit }) {
      router.push('/login').catch(error => {
        if(error.name != "NavigationDuplicated"){
          console.log(error)
          throw error
        }
      })
      commit('SET_LOGGED_OUT', true)
    },
    isLoggedIn() {
      return this.state.user.loggedIn
    },
    isLoggedOut() {
      return this.state.user.loggedOut
    },
    showLoader({ commit }) {
      commit('SET_LOADING', true)
    },
    hideLoader({ commit }) {
      commit('SET_LOADING', false)
    },
    async loadKostenarten({ commit }) {
      const kostenarten = await getDocs(collection(getFirestore(), 'Kostenarten'))
      commit('RESET_KOSTENARTEN')
      kostenarten.forEach(ka => {
        commit('ADD_KOSTENART', {
          id: ka.id,
          name: ka.data().name,
          icon: ka.data().icon
        })
      })
    },
    async loadPauschalenarten({ commit }) {
      const pauschalenarten = await getDocs(collection(getFirestore(), 'Pauschalenarten'))
      commit('SET_PAUSCHALENARTEN')
      pauschalenarten.forEach(pa => {
        commit('ADD_PAUSCHALENART', {
          id: pa.id,
          name: pa.data().name,
          icon: pa.data().icon,
          datum: pa.data().datum,
          uhrzeit: pa.data().uhrzeit
        })
      })
    },
  },
}

export default UserModule
